export const Calendar = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 4H3.5C3.22386 4 3 4.22386 3 4.5V14H15V4.5C15 4.22386 14.7761 4 14.5 4H13V2H14.5C15.8807 2 17 3.11929 17 4.5V16H1V4.5C1 3.11929 2.11929 2 3.5 2H5V4ZM6 5C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5ZM12 5C12.5523 5 13 5.44772 13 6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6C11 5.44772 11.4477 5 12 5ZM11 4H7V2H11V4Z"
      fill="currentColor"
    />
  </svg>
)
